import { Injectable, Injector, forwardRef, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { LoginService } from '../auth/login.service';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
    private loginService: LoginService;

    constructor(@Inject(forwardRef(()=>Injector)) private injector:Injector) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(tap(event => this.handle(event), error => this.handle(error)));
    }

    private handle(event) {
        if (event instanceof HttpErrorResponse && event.status === 401) {
            if(this.loginService == null) this.loginService = this.injector.get(LoginService);
            this.loginService.checkLoginForAuthExpired();
        }
        return event;
    }
}
